import $api from '@/utils/api';
import Logger from '@/utils/logger';

export default {
  async addRecord(data) {
    const response = await $api.post(`/records`, data);

    if (!response.success) {
      Logger.error(response.message);
      return { records: [] };
    }

    return response;
  },

  async getFacilitatorRecords(facilitatorId, learningTypeKey) {
    const response = await $api.get(`/facilitators/${facilitatorId}/records/learning-type-key/${learningTypeKey}`);

    if (!response.success) {
      Logger.error(response.message);
      return { records: [] };
    }

    return response;
  },

  async getClientRecords(clientId) {
    const response = await $api.get(`/clients/${clientId}/records`);

    if (!response.success) {
      Logger.error(response.message);
      return { records: [] };
    }

    return response;
  },
};
